<template>
  <div class="row">
    <h4>Campanhas</h4>
    <div class="col-12">
      <b-card>
        <b-table
          :items="campanhas"
          :busy="loading"
          :fields="headerCampanhas"
          class="mt-3"
          head-variant="light"
          small
          striped
          hover
          bordered
        >
          <template #table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Listando campanhas ...</strong>
            </div>
          </template>
          <template #cell(id)="row">
            <b-button
              size="sm"
              variant="primary"
              v-b-popover.hover.top="'Visualizar campanha'"
              class="mr-3"
              @click="editCampanha(row.value)"
              ><i class="fas fa-eye"></i></b-button>
          </template>
        </b-table>
      </b-card>
    </div>

    <!------------------------------------------------------ Modal Edit Campanha ----------------------------- -->
    <b-modal
      v-model="showModal"      
      size="lg"
      :title="campanhaEdit.nome"
    >
      <b-card>
        <div class="row">
          <div class="col-md-12">
            <strong>Código: </strong> {{ campanhaEdit.codigo }}
            <br />
            <strong>Nome: </strong> {{ campanhaEdit.nome }}
            <br />
            <strong>Cadastrada em </strong>
            {{ formateDate(campanhaEdit.created_at) }}
            <br />
            <strong>Última edição: </strong>
            {{ formateDate(campanhaEdit.updated_at) }}
            <br />
            <strong>Início: </strong> {{ formateDate(campanhaEdit.inicio) }}
            <br />
            <strong>Data Final: </strong>
            {{ formateDate(campanhaEdit.fim) }}
            <br />
            <strong>Data Encerramento: </strong>
            {{ formateDate(campanhaEdit.encerramento) }}
          </div>
        </div>
      </b-card>
      <template #modal-footer>
         <!--  <b-button
            variant="primary float-right mr-3"
            size="sm"
            @click="update(campanhaEdit.id)"
            >Alterar Data de Encerramento
          </b-button>-->
          <b-button
            variant="danger float-right"
            size="sm"
            @click="showModal = false"
            >Fechar
            </b-button>
      </template>
    </b-modal>

  </div>
</template>

<script>
export default {
  props: [],
  data() {
    return {
      datePickerConfig: {
        format: "DD/MM/YYYY HH:mm",
        showClose: true,
      },
      showModal: false,
      showEstados: false,
      campanhas: [],
      headerCampanhas: [
        { key: "codigo", label: "Campanha", sortable: true },
        { key: "nome", label: "Descrição" , sortable: true },        
        { key: "centro_distribuicao" , sortable: true , label: "Centro Dist.", formatter:(value, key, item) => { return value ? value.descricao : "" } },
        { key: "inicio", label: "Dt. Início", formatter:(value, key, item) => { return this.formateDate(value) } },
        { key: "encerramento", label: "Dt. Encerramento", formatter:(value, key, item) => { return this.formateDate(value) } },
        { key: "updated_at", label: "Dt. Alteração", formatter:(value, key, item) => { return this.formateDate(value) } },
        { key: "id", label: "Ver" },
      ],
      campanhaEdit: {},
      listaCidades: [],
      loading: false,
      cidade: "",
      estado: "",
      estados: [],
      cidades: [],
      campanha_id: null,
      editDate: moment().format("DD/MM/YYYY HH:mm"),
    };
  },
  methods: {
    loadCampanhas() {
      $(".loading").show();
      var vm = this;
      axios
        .get("/adm/campanhas/list", { params: { limit: 6}})
        .then(function (resposne) {
          $(".loading").hide();
          vm.campanhas = resposne.data;
        })
        .catch(function (error) {
          var dataErros = error.resposne.data.errors;
          console.log(dataErros);
          if (typeof dataErros == "object") {
            alert(dataErros.join("\n"));
          } else {
            alert(dataErros);
          }

          $(".loading").hide();
        });
    },

    editCampanha(id) {
      $(".loading").show();
      var vm = this;
      vm.showModal = true;
      axios
        .get("/adm/campanhas/" + id)
        .then(function (response) {
          vm.campanhaEdit = response.data;
          vm.editDate = moment(vm.campanhaEdit.encerramento).format(
            "DD/MM/YYYY HH:mm"
          );
          //console.log(vm.campanhaEdit);
          $(".loading").hide();
        })
        .catch(function (error) {
          alert("erro ao carregar a Campanha");
          $(".loading").hide();
          console.log(error);
        });

      vm.showModal = true;
    },
    update(id) {
      const vm = this;
      vm.$swal({
        icon: 'warning',
        title: 'Atenção',
        text: 'Esta ação não poderá ser Revertida, Deseja continuar?',
        showCancelButton: true,
        confirmButtonText: 'Sim, Continuar',
        confirmButtonColor: '#228B22',
        cancelButtonText: 'Cancelar',
      }).then((result) => {
          if (result.value) {
            $(".loading").show();
            var data = {
              _method: "PUT",
              encerramento: moment(vm.editDate).format("YYYY-MM-DD HH:mm"),
            };
            axios
              .post("/adm/campanhas/" + id, data)
              .then(function (response) {
                location.reload();
                $(".loading").hide();
              })
              .catch(function (error) {
                var errors = error.response.data.errors;
                if (typeof errors === "object") {
                   vm.$swal({
                    icon: 'error',
                    title: 'Atenção',
                    text: errors,                   
                  })                  
                } else {
                  alert(errors);
                }
                $(".loading").hide();
                console.log(error);
              });
            vm.showModal = false;
          }
      })
    },

    compararData(date) {
      console.log(moment(date).format("d/M/Y H:m:s"));
      return date;
    },
    formateDate(date) {
      return moment(date).format("DD/MM/YYYY HH:mm:ss");
    },
  
   
  },
  mounted() {
    this.loadCampanhas();
  },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/adm_campanha/Main.vue